import React from "react";
import { BreadCrumb } from "primereact/breadcrumb";

export default function BreadCrumbs({ crumbs }) {
  return crumbs?.length ? (
    <div className="mb-4">
      <BreadCrumb model={crumbs} />
      {/* {items.heading ? (
        <p className="settings-heading">{items.heading}</p>
      ) : (
        <BreadCrumb model={items} />
      )} */}
    </div>
  ) : null;
}
